
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { popupCloseTierShow , signOpenChangeDefaultPassword , walletDetailFetch , authProfileFetch} from "../../actions";
import IntlMessages from "../../utils/IntlMessages";
import { checkLogin } from "../../utils/apiUtil";

import logo from "../../assets/images/es-logo.png";
import {
  reduxForm,
} from "redux-form"; 
 
class PopupTier extends Component {

  render() { 
    const { authMember , handleSubmit , currentPoint } = this.props;
   
    if(!this.props.displayTierShow) {
      return (<div></div>)
    }

    if (!authMember  ) {
      this.props.authProfileFetch();
    }


    if ( !currentPoint && checkLogin()===true) {
      this.props.walletDetailFetch();
    }

    let tier = authMember?.member?.memberLevel
    if(!tier){
      return "";
    }
    return (  
    <div
      className="modal fade show"
      role="dialog"
      tabIndex="-1"
      style={{ display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content white">
          <form onSubmit = {  
            handleSubmit(() => { 
              this.props.push("/");
              // this.props.signOpenChangeDefaultPassword()
            })
          }>
           
            <div className="modal-body">
         
           <h3 style={{ color : "var(--default)"}} > {"Welcome To"}</h3>
           <img src={logo} alt=""></img>
           <hr/>
           <h3 style={{ color : "var(--default)"}} > {"Your Tier: "+tier.toUpperCase()}</h3>
           <h3>   
              <span style={{ color: tier.toUpperCase()=="ELITE"?"var(--default)":"#68737A"}}>Elite</span>  {"/ "} 
              <span style={{ color: tier.toUpperCase()=="STELLAR"?"var(--default)":"#68737A"}}>Stellar</span>  {"/ "} 
              <span style={{ color: tier.toUpperCase()=="PRIME"?"var(--default)":"#68737A"}}>Prime / IIC</span>  </h3>
              <h3 style={{ color :  "var(--default)"}} > {"Your Point: "  } {currentPoint ? currentPoint.toLocaleString("en-US") : ""}  {"points"  }</h3>
              <br/>
            </div>
            <div className="modal-foot container">
              <button
                type="submit"
                className={"btn btn-wrs mb-3"}
                onClick={(e) => this.props.popupCloseTierShow()}
              >
                <IntlMessages id="popup.redeem.get_privilege"></IntlMessages>
              </button>
              {/* <button
                type="button"
                className={""}
                onClick={this.onClickClose}
              >
                <IntlMessages id="consent.decline"></IntlMessages>
              </button> */}
            </div>
          </form>
        </div>
      </div>
    </div>
    );
  }
}


const mapStateToProps = ({ setting, auth , wallet: { detail },}) => {
  const { authMember , displayTierShow } = auth;

  const currentPoint = detail.point;
  const {
    locale: { locale },
  } = setting;


  return { locale, authMember, displayTierShow , currentPoint };
};

PopupTier = reduxForm({  form: "FormConsnt"})(PopupTier);

export default connect(mapStateToProps, {
  push,
  popupCloseTierShow, 
  signOpenChangeDefaultPassword,
  walletDetailFetch,
  authProfileFetch,
})(PopupTier);
